import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePaginatedTasks = ({ search, page, rows = 10 }) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["tasks", search, page, rows, tenantVal],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const params = new URLSearchParams({ page, rows });
      if (search.length >= 3) params.set("searchTerm", search);
      const response = await axiosInstance.get(`${tenantVal}/task/get/open/page?${params}`);

      return response.data;
    },
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching tasks" },
   
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};
